import { downgradeComponent, downgradeInjectable } from "@angular/upgrade/static";
import routing from "@gtmhub/core/routing/module";
import localization from "@gtmhub/localization/module";
import { KpiGroupSelectorComponent } from "@gtmhub/shared/components/kpi-group-selector/kpi-group-selector.component";
import { ParentOkrSelectorComponent } from "@gtmhub/shared/components/parent-okr-selector/parent-okr-selector.component";
import { SuggestionTreeComponent } from "@gtmhub/shared/components/parent-okr-selector/suggestion-tree/suggestion-tree.component";
import mentions from "@gtmhub/shared/mentions/module";
import ngExtensions from "@gtmhub/shared/ng-extensions/ng-extensions.module";
import uiBootstrap from "@gtmhub/ui-bootstrap.module";
import { NumericFieldComponent } from "@webapp/shared/numeric-field/numeric-field.component";
import { RichTextEditorComponent } from "@webapp/shared/rich-text-editor/rich-text-editor.component";
import { UiAvatarComponent } from "@webapp/ui/avatar/avatar.component";
import { UiAssigneeAvatarComponent } from "@webapp/ui/avatar/components/assignee-avatar/assignee-avatar.component";
import { UiAssigneeComponent } from "@webapp/ui/avatar/components/assignee/assignee.component";
import { UiAssigneeAvatarGroupComponent } from "@webapp/ui/avatar/components/avatar-group/assignee-avatar-group.component";
import { UiButtonComponent } from "@webapp/ui/button/button.component";
import { UiIconComponent } from "@webapp/ui/icon/icon.component";
import { UiModalService } from "@webapp/ui/modal/services/modal.service";
import { UiRadioGroupComponent } from "@webapp/ui/radio/components/radio-group/radio-group.component";
import { UiRadioComponent } from "@webapp/ui/radio/radio.component";
import { UiToggleComponent } from "@webapp/ui/toggle/toggle.component";
import {
  AvatarsComponent,
  ConfirmDeleteComponent,
  ConfirmDeleteModalService,
  CreateOkrButtonComponent,
  DropdownActionsMenuComponent,
  EditableTextareaDirective,
  FullNameComponent,
  MetricsAndOwnersComponent,
  SimplePermissionsComponent,
  SnackbarComponent,
  TabAction,
  UsersListTooltipComponent,
} from ".";
import { Permissions } from "../controllers/permissions-directive";
import { TenorGifService } from "../services/tenor-gif.service";
import { AssigneeComponent } from "./assignee/assignee.component";
import { CloseOkrService } from "./close-okrs/close-okr.service";
import { CloseOkrComponent } from "./close-okrs/close-okr/close-okr";
import { OkrStatusModalComponent } from "./close-okrs/okr-status-modal/okr-status-modal.component";
import { OkrStatusLabelComponent } from "./close-okrs/okr-status/okr-status-label.component";
import { OkrStatusComponent } from "./close-okrs/okr-status/okr-status.component";
import { ReopenOkrComponent } from "./close-okrs/reopen-okr/reopen-okr";
import { GhDndListItemComponent } from "./dnd-list-item/dnd-list-item.component";
import { GhDndListComponent } from "./dnd-list/dnd-list.component";
import { EmptyStateBaseComponent } from "./empty-state/empty-state-base/empty-state-base.component";
import { EmptyStateInfoBoxesComponent } from "./empty-state/empty-state-info-boxes/empty-state-info-boxes.component";
import { EmptyStateComponent } from "./empty-state/empty-state.component";
import { EmptyStateService } from "./empty-state/empty-state.service";
import { FeatureNotAvailableComponent } from "./feature-not-available/feature-not-available.component";
import { GenericSessionSelectorComponent } from "./generic-session-selector/generic-session-selector.component";
import { AddGIFComponent } from "./gif/add-gif/add-gif.component";
import { GifViewComponent } from "./gif/gif-view/gif-view.component";
import gridFilteringBar from "./grid-filtering-bar/grid-filtering-bar.module";
import { GridComponent } from "./grid/grid.component";
import { HomeFeedNavBarComponent } from "./home-feed-nav-bar/home-feed-nav-bar.component";
import { HowToStartComponent } from "./how-to-start/how-to-start.component";
import { IncludedInPermissionComponent } from "./included-in-permission/included-in-permission.component";
import ngTagsInput from "./ng-tags-input";
import { NoFilterResultsComponent } from "./no-filter-results/no-filter-results.component";
import { NothingFoundComponent } from "./nothing-found/nothing-found.component";
import { OwnersSelectorComponent, OwnersSelectorModalService } from "./owners-selector/owners-selector.component";
import { PermissionPrincipalComponent } from "./permissions/permission-principal.component";
import { RolesSelectorComponent } from "./roles-selector/roles-selector.components";
import { SessionSelectorDropdownComponent } from "./session-selector-dropdown/session-selector-dropdown.component";
import { SessionTreeSelectorComponent } from "./session-tree-selector/session-tree-selector.component";
import { SharedBannerComponent } from "./shared-banner/shared-banner.component";
import { SingleCollectionSearchComponent } from "./single-collection-search/single-collection-search.component";
import { StatusBarComponent } from "./status-bar/status-bar.component";
import { StatusBarService } from "./status-bar/status-bar.service";
import { SubteamsTreeComponent } from "./subteams-tree/subteams-tree.component";
import { TagsAutocompleteInputComponent } from "./tags-autocomplete-input/tags-autocomplete-input.component";
import { ToggleRightDownArrowComponent } from "./toggle-right-down-arrow/toggle-right-down-arrow.component";
import { TreeSelectorComponent } from "./tree-selector/tree-selector.component";
import { AssigneeChipComponent } from "./ui/assignee-chip/assignee-chip.component";
import { Button } from "./ui/buttons/gh-button/gh-button";
import { DropdownButton } from "./ui/buttons/gh-dropdown-button/gh-dropdown-button";
import { DropdownButtonMenuItem } from "./ui/buttons/gh-dropdown-button/gh-dropdown-button-menu-item";
import { CircleAvatarComponent } from "./ui/circle-avatar/circle-avatar.component";
import { DateDifferenceFilter, DateFilter, DateRangeFilter, TimeAgoFilter } from "./ui/datepicker/date.filter";
import { DatepickerDirective } from "./ui/datepicker/datepicker.directive";
import { DaterangepickerDirective } from "./ui/datepicker/daterangepicker.directive";
import { FormComponent } from "./ui/form/form.component";
import { GhLimitToFilter } from "./ui/gh-limit-to/gh-limit-to.filter";
import { PrivateBadgeComponent } from "./ui/private-badge/private-badge.component";
import { TeamsWithDropdownComponent } from "./ui/teams-with-dropdown/teams-with-dropdown.component";
import { TopNavBarComponent } from "./ui/top-navigation-bar/top-nav-bar.component";
import { UserSelectorComponent } from "./user-selector/user-selector.component";
import { UsersSelectorComponent } from "./users-selector/users-selector.component";
import { ViewMoreAvatarsComponent } from "./view-more-avatars/view-more-avatars.component";
import { WarningModalComponent, WarningModalService } from "./warning-modal/warning-modal.component";

const mod = angular
  .module("sharedComponents", [uiBootstrap, mentions, ngExtensions, ngTagsInput, gridFilteringBar, localization, routing])
  .component("simplePermissions", SimplePermissionsComponent)
  .component("createOkrButton", CreateOkrButtonComponent)
  .component("confirmDelete", ConfirmDeleteComponent)
  .component("closeOkr", CloseOkrComponent)
  .component("reopenOkr", ReopenOkrComponent)
  .component("snackbar", SnackbarComponent)
  .component("dropdownActionsMenu", DropdownActionsMenuComponent)
  .component("topNavBar", TopNavBarComponent)
  .component("avatars", AvatarsComponent)
  .component("circleAvatar", CircleAvatarComponent)
  .component("userSelector", UserSelectorComponent)
  .component("usersSelector", UsersSelectorComponent)
  .component("parentOkrSelector", ParentOkrSelectorComponent)
  .component("suggestionTree", SuggestionTreeComponent)
  .component("kpiGroupSelector", KpiGroupSelectorComponent)
  .component("emptyState", EmptyStateComponent)
  .component("emptyStateInfoBoxes", EmptyStateInfoBoxesComponent)
  .component("emptyStateBase", EmptyStateBaseComponent)
  .component("usersListTooltip", UsersListTooltipComponent)
  .component("teamsWithDropdown", TeamsWithDropdownComponent)
  .component("singleCollectionSearch", SingleCollectionSearchComponent)
  .component("howToStart", HowToStartComponent)
  .component("ghForm", FormComponent)
  .component("okr-status-modal", OkrStatusModalComponent)
  .component("assigneeChip", AssigneeChipComponent)
  .component("noFilterResults", NoFilterResultsComponent)
  .component("nothingFound", NothingFoundComponent)
  .component("treeSelector", TreeSelectorComponent)
  .component("sessionTreeSelector", SessionTreeSelectorComponent)
  .component("fullName", FullNameComponent)
  .component("ghGrid", GridComponent)
  .component("statusBar", StatusBarComponent)
  // to do: move to permissions module - https://gtmhub.atlassian.net/browse/GVS-13832
  .component("subteamsTree", SubteamsTreeComponent)
  .component("gifView", GifViewComponent)
  .component("addGif", AddGIFComponent)
  .component("assignee", AssigneeComponent)
  .component("okrStatus", OkrStatusComponent)
  .component("permissionPrincipal", PermissionPrincipalComponent)
  .component("okrStatusLabel", OkrStatusLabelComponent)
  .component("sessionSelectorDropdown", SessionSelectorDropdownComponent)
  .component("privateBadge", PrivateBadgeComponent)
  .component("homeFeedNavBar", HomeFeedNavBarComponent)
  .component("featureNotAvailable", FeatureNotAvailableComponent)
  .component("ghDndList", GhDndListComponent)
  .component("ghDndListItem", GhDndListItemComponent)
  .component("toggleRightDownArrow", ToggleRightDownArrowComponent)
  .component("sharedBanner", SharedBannerComponent)
  .component("warningModal", WarningModalComponent)
  .component("metricsAndOwners", MetricsAndOwnersComponent)
  .component("ownersSelector", OwnersSelectorComponent)
  .component("rolesSelector", RolesSelectorComponent)
  // to do: move to permissions module - https://gtmhub.atlassian.net/browse/GVS-13832
  .component("includedInPermission", IncludedInPermissionComponent)
  .component("tagsAutocompleteInput", TagsAutocompleteInputComponent)
  .component("genericSessionSelector", GenericSessionSelectorComponent)
  .component("viewMoreAvatars", ViewMoreAvatarsComponent)
  // to do: move to permissions module - https://gtmhub.atlassian.net/browse/GVS-13832
  .directive("permissions", Permissions.factory())
  .directive("richTextEditor", downgradeComponent({ component: RichTextEditorComponent }))
  .directive("ghButton", Button.factory())
  .directive("ghDropdownButton", DropdownButton.factory())
  .directive("ghDropdownButtonMenuItem", DropdownButtonMenuItem.factory())
  .directive("editableTextarea", EditableTextareaDirective.factory())
  .directive("tabAction", TabAction.factory())
  .directive("ghDatepicker", DatepickerDirective.factory())
  .directive("ghDaterangepicker", DaterangepickerDirective.factory({ component: true }))
  .directive("ghDaterangepickerDecorator", DaterangepickerDirective.factory({ component: false }))
  .directive("uiToggle", downgradeComponent({ component: UiToggleComponent }))
  .directive("uiIcon", downgradeComponent({ component: UiIconComponent }))
  .directive("uiButton", downgradeComponent({ component: UiButtonComponent }))
  .directive("uiRadio", downgradeComponent({ component: UiRadioComponent }))
  .directive("uiRadioGroup", downgradeComponent({ component: UiRadioGroupComponent }))
  .directive("uiAvatar", downgradeComponent({ component: UiAvatarComponent }))
  .directive("uiAssigneeAvatar", downgradeComponent({ component: UiAssigneeAvatarComponent }))
  .directive("uiAssigneeAvatarGroup", downgradeComponent({ component: UiAssigneeAvatarGroupComponent }))
  .directive("uiAssignee", downgradeComponent({ component: UiAssigneeComponent }))
  .directive("numericField", downgradeComponent({ component: NumericFieldComponent }))
  .filter("ghDaterange", DateRangeFilter)
  .filter("ghDate", DateFilter)
  .filter("ghTimeAgo", TimeAgoFilter)
  .filter("ghDateDifference", DateDifferenceFilter)
  .filter("ghLimitTo", GhLimitToFilter)
  .service("ConfirmDeleteModalService", ConfirmDeleteModalService)
  .service("EmptyStateService", EmptyStateService)
  .service("StatusBarService", StatusBarService)
  .service("TenorGifService", TenorGifService)
  .service("CloseOkrService", CloseOkrService)
  .service("WarningModalService", WarningModalService)
  .service("OwnersSelectorModalService", OwnersSelectorModalService)
  .service("UiModalService", downgradeInjectable(UiModalService));

export default mod.name;
